import { action } from 'typesafe-actions'
import { GET_TASK_ACTION, SET_TASK_ACTION, SET_IS_LOADING_TASK } from './constants'

export const getTaskActions = (elements: { tagCode: string }) => action(GET_TASK_ACTION, elements)
export const setTaskActions = (actions: any) => action(SET_TASK_ACTION, actions)

export const isTaskActionsLoading = (isLoading: boolean) => action(SET_IS_LOADING_TASK, isLoading)
